import { renderWithNavCopilot } from 'quartz-core/client-with-copilot';
import { history } from 'dashboard-ui-components/lib/history';
// @ts-expect-error migrate upstream file
import DashboardComponent from 'dashboard-ui-components/components/DashboardComponent';
import ProvideReferenceResolvers from './ProvideReferenceResolvers';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from 'DashboardUI/rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { Router } from 'react-router-dom';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import { PlatformDashboardProvider } from 'platform-dashboard-ui/store';

// Apollo Provider
import { ApolloProvider } from '@apollo/client';
import { client } from './graphQL/client';
import UIApplication from 'UIComponents/app/UIApplication';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function renderParentComponent() {
  const ParentComponent = ProvideReferenceResolvers(DashboardComponent);
  renderWithNavCopilot( /*#__PURE__*/_jsx(UIApplication, {
    name: "DashboardUI",
    children: /*#__PURE__*/_jsx(RhumbProvider, {
      trackVisibility: true,
      config: rhumbConfig,
      history: historyAdapter(history),
      children: /*#__PURE__*/_jsx(ApolloProvider, {
        client: client,
        children: /*#__PURE__*/_jsx(PlatformDashboardProvider, {
          children: /*#__PURE__*/_jsxs(Router, {
            history: history,
            children: [/*#__PURE__*/_jsx(OnboardingTour, {}), /*#__PURE__*/_jsx(ParentComponent, {})]
          })
        })
      })
    })
  }), {
    layoutType: 'sidebar'
  });
}